import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Events } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { GlobalVariable } from '../global';

@Injectable()
export class Sadhona {
  private apiUrl = GlobalVariable.BASE_API_URL; //get api url
  constructor(
    public events: Events,
    public storage: Storage,
    public http: HttpClient
  ) {
    this.events.subscribe('sadhona-offline-data-entry', () => {
      this.storage.get('sadhona-offline-data-entry').then((data) => {
        console.log(data);
        for (let item of data) {
          this.insertSadhana(item).subscribe(res => { console.log(res) });
        }
        this.storage.set('sadhona-offline-data-entry', []);
      })
    })
  }

  insertSadhana(formData) {
    return this.http.post(this.apiUrl + 'user/sadhona-sheet', formData)
  }

  getSadhanaSheet(fromdate, todate) {
    return this.http.get(this.apiUrl + `user/sadhona-sheet?fromDate=${fromdate}&toDate=${todate}`)
  }

  getMenteeSadhanaSheet(fromdate, todate, menteeuserid) {
    return this.http.get(this.apiUrl + `user/mentee-sadhona-sheet?fromDate=${fromdate}&toDate=${todate}&menteeuserid=${menteeuserid}`)
  }

  getSingleSadhanaSheet(value) {
    return this.http.get(this.apiUrl + `user/single-sadhona-sheet?fromDate=${value}&toDate=${value}`)
  }

  getSadhanaSheetOption() {
    return this.http.get(this.apiUrl + `user/sadhona-sheet-option`)
  }

  submitMonthSadhana(formData) {
    return this.http.post(this.apiUrl + 'user/month-sadhona-sheet', formData)
  }
  unsubmitMonthSadhana(data) {
    return this.http.post(this.apiUrl + 'user/unsubmit-sadhana', data)
  }
  submittedSadhanaByMonth(year, month) {
    return this.http.get(this.apiUrl + `user/submitted-sadhana-by-month?year=${year}&month=${month}`)
  }
  noofSadhanaByMonth(year, month) {
    return this.http.get(this.apiUrl + `user/noofsadhana-by-month?year=${year}&month=${month}`)
  }

  submittedSadhanaDataByMentor() {
    return this.http.get(this.apiUrl + `user/submiited-sadhana-data`)
  }

  approveSadhana(formData) {
    return this.http.post(this.apiUrl + `user/approve-sadhana`, formData)
  }

  getComments(sequencenumber) {
    return this.http.get(this.apiUrl + `user/get-sadhana-comment?sequencenumber=${sequencenumber}`)
  }

  approvedSadhanaData() {
    return this.http.get(this.apiUrl + `user/get-approved-sadhana`)
  }

  sendSadhanaEmail(formdata) {
    return this.http.post(this.apiUrl + `user/send-sadhana-email`, formdata)
  }

  sendSadhanaReportEmail(fromdate, todate) {
    return this.http.post(this.apiUrl + `user/send-sadhana-report-email`, {fromdate: fromdate, todate: todate})
  }

  getSubmittedApprovedSadhana(year, month, userId) {
    return this.http.get(this.apiUrl + `user/submitted-sadhana-by-user?year=${year}&month=${month}&userid=${userId}`)
  }

}



// WEBPACK FOOTER //
// ./src/providers/sadhona.ts